import {useMemo} from 'react';
import { FluxAccordion } from '@meltwater/flux-web-components-react';
import { MaterialReactTable } from 'material-react-table';
import { Paper, Typography } from '@mui/material';
import styles from './sendgrid.module.css';

function TrackedCompany({ item, idx }) {
  const columns = useMemo(
    () => [
      {
        header: 'Email',
        accessorKey: 'email',
        size: 200,
      },
      {
        header: 'Reason',
        accessorKey: 'reason',
        grow: true,
        minSize: 250
      },
      {
        header: 'Status',
        accessorKey: 'status',
        size: 100,
      },
      {
        header: 'Created',
        accessorKey: 'created',
        accessorFn: (row) => {
          try {
            return new Date(row.created * 1000).toLocaleString();
          } catch (e) {
            return 'Invalid date';
          }
        },
        size: 150
      }
    ],
    [],
  );
  
  return (
    <div key={idx} className={styles.mb16}>
      <Paper elevation={2} sx={{ borderRadius: '8px', overflow: 'hidden' }}>
        <FluxAccordion key={idx} summary={`${"" || item.companyname} - ${"" || item.companyid}`}>
          <div slot="summary" style={{ padding: '8px 16px' }}>
            <Typography variant="h6" sx={{ fontWeight: 500, color: '#188182' }}>
              {item.companyname || 'Unknown Company'} - {item.companyid || 'No ID'}
            </Typography>
          </div>
          
          <div style={{ padding: '0 16px 16px' }}>
            <MaterialReactTable
              columns={columns}
              data={item.data || []}
              density={'comfortable'}
              enableStickyHeader
              layoutMode='grid'
              enableColumnFilterModes={true}
              enableGrouping={true}
              enableColumnPinning={true}
              enableFacetedValues={true}
              expanded={true}
              enableGlobalFilter={false}
              muiTablePaperProps={{ 
                elevation: 0,
                sx: { 
                  borderRadius: '8px',
                  border: '1px solid #e0e6e8'
                } 
              }}
              initialState={{ 
                expanded: true, 
                density: 'comfortable', 
                columnVisibility: { 
                  Boolean: false, 
                  Language: false, 
                  AnySearches: false, 
                  AllSearches: false, 
                  NotSearches: false, 
                  Country: false, 
                  Query: false, 
                  FilterName: false, 
                  FilterID: false 
                }, 
                pagination: { pageSize: 100 } 
              }}
            />
          </div>
        </FluxAccordion>
      </Paper>
    </div>
  );
}

export default TrackedCompany;